import { createResponsiveStateReducer } from 'redux-responsive'

// bootstrap $grid-breakpoints: (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1920px);
export default createResponsiveStateReducer({
  xs: 768,
  sm: 1024,
  md: 1280,
  lg: 1550,
  xl: 1919,
})

export const sIsMobile = state => state.browser.lessThan.sm
export const sIsTablet = state => state.browser.lessThan.md
